function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgPhonebook = function SvgPhonebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.52 491.52",
    style: {
      enableBackground: "new 0 0 491.52 491.52"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M25.275,0C11.317,0,0,11.316,0,25.275v440.971c0,13.959,11.317,25.274,25.275,25.274h72.311V0H25.275 z"
  }), React.createElement("path", {
    style: {
      fill: "#27A2DB"
    },
    d: "M408.938,0H97.586v491.52h311.352c13.959,0,25.274-11.315,25.274-25.274V25.275 C434.212,11.316,422.897,0,408.938,0z"
  }), React.createElement("path", {
    style: {
      fill: "#2D93BA"
    },
    d: "M97.586,487.445v4.075h311.352c13.959,0,25.274-11.315,25.274-25.274V25.275 c0-6.829-2.735-13.001-7.136-17.549L97.586,487.445z"
  }), React.createElement("rect", {
    x: 434.227,
    y: 35.267,
    style: {
      fill: "#3EA69B"
    },
    width: 13.199,
    height: 131.707
  }), React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M491.52,152.373V49.867c0-8.063-6.536-14.6-14.599-14.6H447.41v131.705h29.511 C484.984,166.972,491.52,160.436,491.52,152.373z"
  }), React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M476.921,309.652c8.063,0,14.599-6.536,14.599-14.6V192.547c0-8.063-6.536-14.6-14.599-14.6H447.41 v131.705H476.921z"
  }), React.createElement("rect", {
    x: 434.227,
    y: 177.946,
    style: {
      fill: "#D15241"
    },
    width: 13.199,
    height: 131.707
  }), React.createElement("rect", {
    x: 434.227,
    y: 324.557,
    style: {
      fill: "#F6C358"
    },
    width: 13.199,
    height: 131.707
  }), React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M476.921,456.253c8.063,0,14.599-6.536,14.599-14.6V339.147c0-8.063-6.536-14.6-14.599-14.6H447.41 v131.705H476.921z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.507,173.687c3.811-1.955,5.334-6.404,3.296-9.519l-37.573-57.458 c-1.609-2.46-4.936-3.304-8.04-1.993c-4.433,1.873-11.197,4.851-18.529,8.49l45.155,69.052 C263.477,178.938,269.202,175.895,273.507,173.687z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M394.232,354.045c2.446-2.318,3.007-5.704,1.398-8.165l-37.573-57.458 c-2.038-3.116-6.724-3.505-10.043-0.797c-3.749,3.059-8.832,7.083-14.143,10.938l45.155,69.052 C385.298,362.358,390.739,357.355,394.232,354.045z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.3,311.171c-44.627,0.823-92.13-71.821-73.484-112.374c1.504-3.273,6.838-7.5,13.229-11.698 l-45.549-69.654c-14.233,7.707-28.231,17.239-30.107,25.709c-16.175,73.043,88.457,233.048,161.857,247.516 c8.512,1.678,22.856-7.325,35.623-17.274l-45.549-69.654C319.913,307.913,313.901,311.104,310.3,311.171z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhonebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phonebook.9201b136.svg";
export { ForwardRef as ReactComponent };